import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import MedicalEventForm from "./MedicalEventForm";
import useMedicalEvents from "./Hooks/useMedicalEvents";
import axios from "axios";
import {isLoading} from "../../../Shared/StateHelper";
import Loader from "../../../Shared/Loader";
import Helper from "../../../Shared/Helper";

const CreateMedicalEvent = () => {
    const csrfToken = document.querySelector('[name=csrf-token]').content;
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    const nav = useNavigate();
    const {id} = useParams();
    const onEdit = !!id;

    const [medicalEvent, setMedicalEvent] = useState({name: "", date: undefined, time: undefined, guests: []});
    const {create, get, update, state: requestState} = useMedicalEvents(id, false);

    useEffect(() => {
        if(onEdit) get(id).then(res => setMedicalEvent(res.data));
    }, [id]);

    if(onEdit && isLoading(requestState)) return <div style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
        <Loader/>
    </div>

    const canSave = () => {
        if(!medicalEvent.orthoptiste_id || !medicalEvent.ophtalmologiste_id) return false;
        return !!medicalEvent.name;
    }

    const createButton = () => {
        return <a className={`btn blue darken-2 z-depth-0 ${canSave() ? "" : "disabled"}`}
                  style={{marginInline: 20, marginLeft: "auto"}}
                  onClick={() => create(medicalEvent).then(() => nav("/medical_events"))}
        >
            <i className={"material-icons left"}>save</i>
            Créer
        </a>
    }

    const updateButton = () => {
        return <a className={`btn blue darken-2 z-depth-0 ${canSave() ? "" : "disabled"}`}
                  style={{marginInline: 20, marginLeft: "auto"}}
                  onClick={() => update(medicalEvent).then(() => nav("/medical_events"))}
        >
            <i className={"material-icons left"}>save</i>
            Mettre à jour
        </a>
    }

    return <div style={{height: "100%", overflowY: "scroll"}}>
        <div className="valign-wrapper" style={{marginLeft: 10}}>
            <a className="btn-flat" style={{borderRadius: 20}} onClick={() => nav("/medical_events")}>
                <i className="material-icons">arrow_back</i>
            </a>
            <h3 className="valign-wrapper" style={{margin: 20}}><i className="material-icons left">event</i>
                Créer un nouvel évènement
            </h3>
            {onEdit ? updateButton() : createButton()}
        </div>
        <div className="divider"/>
        <div className="row" style={{padding: 20, gap: 10, minHeight: 400}}>
            <MedicalEventForm medicalEvent={{...medicalEvent, date: Helper.dateFromDateTime(medicalEvent.date), time: medicalEvent.time ? medicalEvent.time : Helper.timeFromDateTime(medicalEvent.date)}}
                              onChange={setMedicalEvent}/>
        </div>
    </div>
}

export default CreateMedicalEvent;